import RmsAdapter from './rms';

export default class DeskLocationAdapter extends RmsAdapter {
  urlForFindAll(_, { adapterOptions }) {
    const url = super.urlForFindAll(...arguments);
    return `${url}?filter[company-id]=${adapterOptions.companyId}`;
  }
}
